<template>
  <div>
    <vue-element-loading
      :active="appLoading"
      :is-full-screen="true"
      background-color="#FFFFFF"
      color="#FDCE48"
      spinner="bar-fade-scale"
    />
    <ServerError v-if="ServerError" />
    <v-snackbar v-model="showSnackBar" color="#FDCE48" right :timeout="timeout">
      <v-layout wrap justify-center>
        <v-flex text-left class="align-self-center">
          <span style="color: #000">
            {{ msg }}
          </span>
        </v-flex>
        <v-flex text-right>
          <v-btn small :ripple="false" text @click="showSnackBar = false">
            <v-icon style="color: #000">mdi-close</v-icon>
          </v-btn>
        </v-flex>
      </v-layout>
    </v-snackbar>
    <v-layout wrap justify-center>
      <v-flex xs12 text-left>
        <span class="itemHeading"> Dashboard </span>
      </v-flex>
    </v-layout>
    <v-layout wrap justify-center py-4>
      <v-flex xs12>
        <Analytics v-bind:storage="dashboard" />
      </v-flex>
    </v-layout>
    <v-layout wrap justify-center>
      <v-flex py-2>
        <v-divider></v-divider>
      </v-flex>
    </v-layout>
    <v-layout wrap justify-center>
      <v-flex xs12 py-2 text-left>
        <span class="itemHeading">Map</span>
      </v-flex>
      <v-flex xs12>
        <UsersMap />
      </v-flex>
    </v-layout>
    <v-layout wrap justify-start>
      <v-flex xs12 md5 lg4 xl4>
        <v-layout wrap justify-start>
          <v-flex xs12 py-2 text-left>
            <span class="itemHeading">Honey Types</span>
          </v-flex>
          <v-flex xs12 v-if="dashboard.iventoryData">
            <HoneyTypes
              v-bind:storage="dashboard.iventoryData"
              :key="dashboard.iventoryData.label.length"
            />
          </v-flex>
        </v-layout>
      </v-flex>
      <v-flex xs12 md7 lg8 xl8>
        <v-layout wrap justify-start>
          <v-flex xs12 py-2 text-left>
            <span class="itemHeading"> Apiaries </span>
          </v-flex>
          <v-flex xs12 v-if="dashboard.apiaryGraph">
            <ApiariesChart
              v-bind:storage="dashboard.apiaryGraph"
              v-bind:hives="dashboard.colonyGraph[0]"
              :key="dashboard.apiaryGraph.length"
            />
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
    <v-layout wrap justify-start py-4>
      <v-flex xs12 md6 xl4 pr-md-4>
        <v-card elevation="6" min-height="40vh">
          <v-layout wrap justify-center>
            <v-flex xs12 pa-2>
              <Apiaries v-bind:storage="dashboard.lasttenapiries" />
            </v-flex>
          </v-layout>
        </v-card>
      </v-flex>
      <v-flex xs12 md6 xl4 pl-md-4 px-xl-4 pt-4 pt-md-0>
        <v-card elevation="6" min-height="40vh">
          <v-layout wrap justify-center>
            <v-flex xs12 pa-2>
              <Users v-bind:storage="dashboard.lasttenusers" />
            </v-flex>
          </v-layout>
        </v-card>
      </v-flex>
      <v-flex xs12 md6 xl4 pr-md-4 pr-xl-0 pt-4 pt-xl-0 pl-xl-4>
        <v-card elevation="6" min-height="40vh">
          <v-layout wrap justify-center>
            <v-flex xs12 pa-2>
              <Hives v-bind:storage="dashboard.lasttencolonies" />
            </v-flex>
          </v-layout>
        </v-card>
      </v-flex>
    </v-layout>
  </div>
</template>
<script>
import axios from "axios";
import Analytics from "./analytics";
import Apiaries from "./apiaries";
import Users from "./users";
import Hives from "./hives";
import UsersMap from "./usersMap";
import HoneyTypes from "./honeyTypes";
import ApiariesChart from "./apiariesChart";
export default {
  components: {
    Analytics,
    Apiaries,
    Users,
    Hives,
    UsersMap,
    HoneyTypes,
    ApiariesChart,
  },
  data() {
    return {
      appLoading: false,
      ServerError: false,
      showSnackBar: false,
      timeout: 5000,
      msg: null,
      dashboard: {},
    };
  },
  beforeMount() {
    this.getData();
  },
  methods: {
    getData() {
      this.appLoading = true;
      axios({
        method: "GET",
        url: "/user/dashboard",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
      })
        .then((response) => {
          this.appLoading = false;
          if (response.data.status == true) {
            this.dashboard = response.data.data;
          }
        })
        .catch((err) => {
          this.appLoading = false;
          console.log(err);
        });
    },
  },
};
</script>